{
  "AutocalcdurationLabel": "Calcolo automatico della durata durante la pianificazione del rapporto:",
  "BundleallemailattachinzipLabel": "Accorpate tutti gli allegati e-mail in un file zip:",
  "RunandcollatewithsimilarschedLabel": "Esecuzione e collazione con programmi di rapporti periodici simili:",
  "Advanced_SectionHeader": "Avanzato",
  "NAME": "Advanced"
}